

RegionRedirect();


function RegionRedirect(){
  

    var returnCustomer,
    	regionChanged,    	
        locationRequest,
        country,
        redirectRequired;       	
  	
    
    returnCustomer = checkIfReturnCustomer();      
  	regionChanged  = checkifRegionChanged();
  
    if( !returnCustomer ){      
      rememberCustomer();	        
    }

  	
    if( !returnCustomer && !regionChanged ){
            
      locationRequest = getLocation();

      locationRequest.done( function(data){

        if( data.country ){	          
          country = data.country;          
          
          redirectRequired = checkIfRedirectRequired( country );                              
          
          if( redirectRequired ){
          	redirectCustomer();
          }  
          
        }  

      });
    }
  	  	
  
  function checkifRegionChanged(){
  	
    var regionChanged = false;
    
    if( window.location.search == "?regionChanged" ){
      regionChanged = true;
    }
    
    return regionChanged;
  } 
  
  function checkIfReturnCustomer(){

    var returnCustomer = false;
    if( localStorage.getItem('returnCustomer')  ){
      returnCustomer = true;
    }    

    return returnCustomer;

  }

  function rememberCustomer(){
    localStorage.setItem('returnCustomer', true);
  }    

  function getLocation(){

    var request = $.ajax({
      url: "https://pro.ip-api.com/json/?key=x21IQsQLynHu4jd",
      method: "GET",        
      dataType: "json"
    });

    return request;

  }
  
  function checkIfRedirectRequired( country ){
    
    var redirectRequired = false;

    if( country !== "United States" ){

      EUCustomer = checkIfEUCustomer(country);      
      
      if( EUCustomer ){
        redirectRequired = true;
      }

    }

    return redirectRequired;
    
  }
  

  function checkIfEUCustomer(country){

    var EUCustomer = false,
    	includedCountries = [
      "United Kingdom", "Switzerland", "Norway", "Belgium", "Greece", "Lithuania", "Portugal", 
      "Bulgaria", "Spain", "Luxembourg", "Romania","Czechia", "France", "Hungary", "Slovenia", 
      "Denmark", "Croatia", "Malta", "Slovakia", "Germany", "Italy", "Netherlands", "Finland",  
      "Estonia", "Cyprus", "Austria", "Sweden", "Ireland", "Latvia", "Poland"
    ];
	
    if( includedCountries.indexOf(country) > -1  ){
      EUCustomer = true;
    }    

    return EUCustomer;

  }


  function redirectCustomer(){
    var EUSiteURL = "https://eu.lifestraw.com?regionChanged";
    window.location.href = EUSiteURL;
  }


}  


